export function includeCurrentUrlString(urlSearch) {
    const currentUrl = window.location.pathname;
    const regex = new RegExp(urlSearch);
    if (regex.test(currentUrl)) {
        return true;
    }
    return false;
}
